export const montserratFontCssUrl = "https://fonts.googleapis.com/css2?family=Montserrat:wght@400;700&display=swap";

export const tinymceFontFamilyFormats = [
  "Andale Mono=andale mono,times",
  "Arial=arial,helvetica,sans-serif",
  "Arial Black=arial black,avant garde",
  "Book Antiqua=book antiqua,palatino,serif",
  "Comic Sans MS=comic sans ms,sans-serif",
  "Courier New=courier new,courier,monospace",
  "Georgia=georgia,palatino,serif",
  "Helvetica=helvetica",
  "Montserrat=Montserrat,sans-serif",
  "Impact=impact,chicago,sans-serif",
  "Symbol=symbol",
  "Tahoma=tahoma,arial,helvetica,sans-serif",
  "Terminal=terminal,monaco,monospace",
  "Times New Roman=times new roman,times,serif",
  "Trebuchet MS=trebuchet ms,geneva,sans-serif",
  "Verdana=verdana,geneva,sans-serif",
  "Webdings=webdings",
  "Wingdings=wingdings,zapf dingbats",
].join("; ");

export const templateTinymceToolbar =
  "varMenuButton | uploadFile | fontfamily | bold italic underline forecolor backcolor | undo redo | link image code | alignleft aligncenter alignright alignjustify | outdent indent |  numlist bullist | print | charmap | fullscreen code";
